/**
 * State used in rendering MessageBar
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
